import React, { useState } from 'react'
import { Input } from '../../components/ui/input'
import { Label } from '../../components/ui/label'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '../../components/ui/Card'
import { Link, useNavigate } from 'react-router-dom'
import { Button } from '../../components/ui/button'
import Logo from "../../assets/images/IRStructureLogo.png"
import { Eye, EyeOff } from 'lucide-react'
import { login } from '../../store/actions/auth/login'
import { useDispatch, useSelector } from 'react-redux'
import ForgetPasswordModal from './ForgetPasswordModal'
import Loading from '../../components/common/Loading'

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoading = useSelector((state) => state.isLoading);
  const [forgetModal, setForgetModal] = useState(false);
  const [error, setError] = useState({});
  const [userInfo, setUserInfo] = useState({
    email: '',
    password: '',
  })
  const [passwordVisible, setPasswordVisible] = useState(false); // Add this state

  const handleChange = (e) => {
    setUserInfo({ ...userInfo, [e.target.name]: e.target.value })
  }

  const handleValidation = () => {
    let errors = {};
    let isValid = true;
    if (userInfo.email === '') {
      errors['email'] = 'Please enter your email';
      isValid = false;
    }
    if (userInfo.password === '') {
      errors['password'] = 'Please enter a password';
      isValid = false;
    }

    setError(errors);
    return isValid;
  };

  const handleSubmit = (e) => {
    if (handleValidation()) {
      dispatch(login(userInfo, navigate))
    }
  }
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  return (
    <div className='flex justify-center items-center  h-screen p-4'>
      <Card className="max-w-2xl w-full relative">
        <div className='flex justify-center items-center pt-4'>
          <img className='absolute -top-16 left-[30%] w-56' src={Logo} alt="" />
        </div>
        <CardHeader className="py-3">
          <CardTitle className="text-2xl font-500">Sign In</CardTitle>
          <CardDescription>
          Welcome back — sign in to continue.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-2">
          <div className="space-y-1">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" name="email" placeholder="name@gmail.com" onChange={(e) => handleChange(e)} onKeyPress={handleKeyPress} autoComplete='off' />
            <div className={error['email'] ? "text-rose-600" : ''}>{error['email'] ? error['email'] : null}</div>
          </div>
          <div className="space-y-1 relative">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type={passwordVisible ? 'text' : 'password'} name="password" placeholder="********" onChange={handleChange} onKeyPress={handleKeyPress} autoComplete='off' />
            <Button className="w-12 bg-transparent order-last py-2 px-0  hover:!bg-transparent border-s absolute right-0 top-[1.6rem] rounded-ss-none rounded-es-none" onClick={togglePasswordVisibility}>
              {passwordVisible ? <EyeOff className='text-black' /> : <Eye className='text-black' />}
            </Button>
            <div className={error['password'] ? "text-rose-600" : ''}>{error['password'] ? error['password'] : null}</div>
          </div>
        </CardContent>
        <CardFooter className="sm:flex flex-col items-center justify-between block space-y-2">
          <Button className="w-full" onClick={handleSubmit} disabled={isLoading}>{isLoading ? <><Loading height={16} width={16} color="#ffffff" strokeColor="#ffffff" />Continuing...</> : 'Continue'}</Button>
          <div className="flex justify-between items-center w-full">
            <Link to="/register" className="text-[13px]">
              Don’t have an account?
              <span className="ml-1 text-sm font-semibold hover:underline text-gray-700">
                 Sign Up
              </span>
            </Link>
            <span
              onClick={() => setForgetModal(true)}
              className="text-sm font-semibold hover:underline text-gray-700 cursor-pointer"
            >
              Forgot Password?
            </span>
          </div>
        </CardFooter>
        <ForgetPasswordModal show={forgetModal} onHide={() => setForgetModal(false)} />
      </Card>
    </div>
  )
}

export default Login